var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgQualitativeIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1367_1233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 2.26764V12.9343H14V14.2676H2V2.26764H3.33333ZM13.2933 4.22764L14.7067 5.64097L10.6667 9.68231L8.66667 7.68231L6.04 10.309L4.62667 8.89431L8.66667 4.85431L10.6667 6.85431L13.2933 4.22764Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1367_1233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.267639)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgQualitativeIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/QualitativeIcon.f8a0736c.svg";
export { ForwardRef as ReactComponent };